import MLR from 'ml-regression-multivariate-linear';
import math from "mathjs";
import {get_factors_w_lags, r_squared, scaled_weights, predict, normalized, progress_value} from './model-util';

let data;
let times;

let lags;
let first = 1882;
let start = 1979;

let temps;
let factors;
let model;
let stats;

let norm_temps;
let norm_factors;
let norm_model;

let best_fit;
let best_rsquared;

let months = ["Jan.", "Feb.", "March", "April", "May", "June", "July", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];

/*
Initialize times and temps from beginning and keep constant; only change feature space
 */
export function initializeModel(content){
    data = content;

    /* Standard model specs */
    lags = [[0, 3, 10], [3, 10], [1], [0]];
    const offset = (start - first) * 12;
    times = data.map((row) => row[0]).slice(offset, data.length);

    temps = data.map((row) => row[3]).slice(offset, data.length);
    stats = {"mean": math.mean(temps), "std": math.std(temps)};

    factors = get_factors_w_lags(data, lags, offset);
    model = new MLR(factors, temps.map((value) => [value]));

    best_fit = predict(model.weights, factors);
    best_rsquared = r_squared(temps, best_fit);

    norm_factors = normalized(factors);
    norm_temps = temps.map((temp) => (temp - math.mean(temps)) / math.std(temps));
    norm_model = new MLR(norm_factors, norm_temps.map((value) => [value]));
}


export function adjustModel(enso_lags, volc_lags, sol_lags, anth_lags){
    lags = [enso_lags, volc_lags, sol_lags, anth_lags];

    factors = get_factors_w_lags(data, lags,(start - first) * 12);
    model = new MLR(factors, temps.map((value) => [value]));

    norm_factors = normalized(factors);
    norm_model = new MLR(norm_factors, norm_temps.map((value) => [value]));
    /* console.log("Model coefficients: " + model.weights); */
}

export function getPredictions(f1 = 1, f2 = 1, f3 = 1, f4 = 1){
    /*
    Note that normalization is key for getting the predictions where coefficients have been scaled.
    This ensures coefficients are one same scale, thus can be scaled uniformly.
     */
    let adj_norm_weights = scaled_weights(norm_model.weights, f1, f2, f3, f4);
    let predictions = predict(adj_norm_weights, norm_factors);
    predictions = predictions.map(prediction => (prediction * stats['std'] + stats['mean']));

    let output = times.map((date, idx) => [{v: date, f: timeToString(date)}, temps[idx], best_fit[idx], predictions[idx]]);
    output.splice(0, 0, ["times", "Ta Observed", "Ta Best Fit Model", "Ta Adjustable Model"]);
    /* console.log("Current R^2: " + r_squared(temps, predictions));
    console.log("Current Fit Index: " + progress_value(temps, best_fit, predictions)); */
    let fit_indicator = (f1 === 1 && f2 === 1 && f3 === 1 && f4 === 1) ? r_squared(temps, predictions) : progress_value(temps, best_fit, predictions);
    return {"graph_data": output, "progress_bar_data": {"standard": best_rsquared, "current": fit_indicator}};
}

export function timeToString(time){
    let year = Math.trunc(time);
    let month = ((time - year) * 12) + 0.5;
    return months[Math.round(month)-1] + " " + year
}


export function getComponents(f1 = 1, f2 = 1, f3 = 1, f4 = 1){
    let components = [];

    for(let i=0; i<4; i++){
        let adj_norm_weights = scaled_weights(norm_model.weights, i === 0 ? f1 : 0.0, i === 1 ? f2 : 0.0, i === 2 ? f3 : 0.0, i === 3 ? f4 : 0.0);
        components.push( predict(adj_norm_weights, norm_factors) );
    }
    let output = times.map((date, idx) => [{v: date, f: timeToString(date)}, components[0][idx] * stats['std'],
                                                                             components[1][idx] * stats['std'],
                                                                             components[2][idx] * stats['std'],
                                                                             components[3][idx] * stats['std']]);
    output.splice(0, 0, ["time", "ENSO", "volc.", "sol.", "anth."]);
    return output
}

